import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Avatar from '@mui/material/Avatar';
import StickyNote2SharpIcon from '@mui/icons-material/StickyNote2Sharp';

const useStyles = makeStyles((theme) => ({
  avatarImg: {
    display: 'flex',
    width: theme.spacing(3),
    height: theme.spacing(3)
  },
  avatarRoot: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    borderRadius: '50%',
    borderWidth: `2px solid ${theme.palette.background.paper}`,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    backgroundColor: theme.palette.common.white
  },
  avatarIcon: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    color: theme.palette.noteListIcon.empty
  }
}));
type SourceAvatarProps = {
  name: string;
  src: string | undefined;
};
const SourceAvatar: React.FC<SourceAvatarProps> = ({
  name,
  src
}: SourceAvatarProps) => {
  const classes = useStyles();
  if (!src) {
    return (
      <Avatar
        alt={name}
        classes={{ img: classes.avatarImg, root: classes.avatarRoot }}
        data-testid={'source-by-time-chart-avatar-manual'}
      >
        <StickyNote2SharpIcon className={classes.avatarIcon} />
      </Avatar>
    );
  }
  return (
    <Avatar
      alt={name}
      src={src}
      classes={{ img: classes.avatarImg, root: classes.avatarRoot }}
      data-testid={'source-by-time-chart-avatar'}
    />
  );
};
export default React.memo(SourceAvatar);
